module.exports = __webpack_public_path__ + "static/media/kyc_personal_details.0aef8e6f.svg";